var printer = null;
var ePosDev = null;
export const epsonClient = {
    methods: {
        PrintSlip: function(){
            if(ePosDev == null)
                Init();
            if(printer == null)
                ConnectAndPrint();
            else
                Print();
        }
    }
}

function Init() {
    ePosDev = new window.epson.ePOSDevice();
}

function ConnectAndPrint() {
    var ipAddress = '192.168.1.107';
    var port = '8008';
    window.alert('Locating printer');
    ePosDev.connect(ipAddress, port, Callback_Connect);
}

function Callback_Connect(resultConnect) {
    var deviceId = 'local_printer';
    var options = { 'crypto': false, 'buffer': false };
    if ((resultConnect == 'OK') || (resultConnect == 'SSL_CONNECT_OK')) {
        //Retrieves the Printer object
        window.alert('Printer located');
        ePosDev.createDevice(deviceId, ePosDev.DEVICE_TYPE_PRINTER, options, Callback_CreateDevice);
    }
    else {
        //Displays error messages
        window.alert('Error:\n' + 'Failed to find printer on the network')
    }
}

function Callback_CreateDevice(deviceObj) {
    if (deviceObj === null) {
        //Displays an error message if the system fails to retrieve the Printer object
        window.alert('Error:\n' + 'Failed to connect to printer')
        return;
    }
    printer = deviceObj;
    window.alert('Printer connected');
    //Registers the print complete event
    printer.onreceive = function (response) {
        if (response.success) {
            //Displays the successful print message
            window.alert('Printing completed');
        }
        else {
            //Displays error messages
            window.alert('Error:\n' + response)
        }
    };

    Print();
}

function Print() {
    if (ePosDev.isConnected && printer != null) {
        window.alert('Printing...');

        var ctx = Draw();
        var canvas = document.getElementById('myCanvas');

        printer.addTextAlign(printer.ALIGN_CENTER);
        printer.addImage(ctx, 0, 0, canvas.width, canvas.height, printer.COLOR_1, printer.MODE_MONO);
        printer.addText('I did it!');
        printer.addFeedLine(1);
        printer.addText('This is running offline!');
        printer.addFeedLine(5);
        printer.addCut()

        printer.send();
    }
}

function Draw() {
    var canvas = document.getElementById('myCanvas');
    var ctx = canvas.getContext('2d');
    var img = document.getElementById('image');
    img.crossOrigin = 'Anonymous';
    ctx.canvas.width = img.width;
    ctx.canvas.height = img.height;
    ctx.drawImage(img, 0, 0, ctx.canvas.width, ctx.canvas.height);

    return ctx;
}